import { createContext } from 'react'
import { RoomController, RoomConnectorsController } from '@evertel/room'
import { UserSettingsController } from '@evertel/blue-user'
import { RoomJoinRequestsController } from '@evertel/room'

export interface RoomContextProps {
    canManageRoom: boolean
    roomController: RoomController
    roomConnectorsController: RoomConnectorsController
    userSettingsController: UserSettingsController
    roomJoinRequestsController: RoomJoinRequestsController
    setIsMessageSearchModalOpen: (state: boolean) => void
    toggleAside: (tab: string, intent: 'open'|'close', props?: any) => void
    asideOpenComplete: boolean
}

export const RoomContext = createContext({} as RoomContextProps)
